module.exports = __webpack_public_path__ + "img/s13.5e8a656e.png";